import { render, staticRenderFns } from "./ListsView.vue?vue&type=template&id=6b229f16&"
import script from "./ListsView.vue?vue&type=script&lang=js&"
export * from "./ListsView.vue?vue&type=script&lang=js&"
import style0 from "./ListsView.vue?vue&type=style&index=0&id=6b229f16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports